// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
export let DirectBrokerMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_BROKER_MESSAGE)

    this.ID = null
    this.Text = null
    this.TextMessageType = null
    this.SenderID = null
    this.TargetID = null
    this.Date = null
    this.Name = null
    this.ColorHEX = null
    this.ProductID = null
    this.ShowPopUp = null
    this.IsUnread = null
    this.ResponseCases = null
    this.CustomButtons = null
    this.DisplayMethod = TextDisplayMethod.Text;
}

DirectBrokerMessage.prototype = Object.create(DirectMessageBase.prototype)

DirectBrokerMessage.prototype.AddCustomButton = function (brokerMessageCustomButton)
{
    if (!brokerMessageCustomButton)
        return

    if (!this.CustomButtons)
        this.CustomButtons = []

    this.CustomButtons.push(brokerMessageCustomButton)
}

DirectBrokerMessage.prototype.IsHTMLDisplayMethod = function ()
{
    return this.DisplayMethod == TextDisplayMethod.Html
}

let TextDisplayMethod =
{
    Text: 0,
    Html: 1
}